// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskBindingRequestTaskVersion } from './taskBindingRequestTaskVersion';

/**
 * Task binding used inside SlotBindingRequest.
 */
export interface TaskBindingRequest {
  taskId: string;
  /** Concrete task version or any */
  taskVersion?: TaskBindingRequestTaskVersion;
}
